import { purchaseOrderStatusName } from '../constants/purchase-order-status.js';
export function canEditPurchaseOrderHeader(statusName) {
    return statusName === purchaseOrderStatusName.DRAFT;
}
//# sourceMappingURL=can-edit-purchase-order-header.js.map